import React from 'react';
import PropTypes from 'prop-types';

function TextEffects({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      {' '}
      <g strokeLinecap="round" strokeLinejoin="round">
        <path d="m15.56 11.91-3.08-6.6a.54.54 0 0 0-.34-.28c-.3-.1-.64.03-.75.28l-3 6.6m7.17 0H8.4m7.16 0L17 15m-8.6-3.09L7 15M8 18h8s-2.34.61-3.56 1c-1.21.39-2.66 1-2.66 1s1.37.23 2.22.5c.53.17 1.33.5 1.33.5" />
      </g>{' '}
    </svg>
  );
}

TextEffects.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default TextEffects;
